import React, { useContext, useState, useRef } from 'react'
import { vistaConsultorasContext } from './VistaConsultorasAdmin'
import IcoList from "../../../assets/img/ico-list.svg"
import { Oval } from 'react-loader-spinner'
import { CSSTransition } from 'react-transition-group'
import ListaEmpleados from './ListaEmpleados'
import "./SAConsultora.scss"
import { useAdmin } from '../../../context/AdminContext'
import ModalEmpresa from '../../Modales/Admin/superAdmin/ModalEmpresa'
import ListaAreas from './ListaAreas'

export const listaEmpresasContext = React.createContext()

function ListaEmpresas() {
  const { user, idConsultora } = useContext(vistaConsultorasContext)

  const { 
    empresas,
    errorEmpresa,
    loadingEmpresas,
    fetchEmpleadosById,
  } = useAdmin()

  const [expandedRowEmpleados, setExpandedRowEmpleados] = useState(null)

  const [modalEmpresa, setModalEmpresa] = useState(false)
  const [objEmpresa, setObjEmpresa] = useState(null)

  const [idEmpresa, setIdEmpresa] = useState(null)

  const handleEmpleadosById = async (id) => {
    setExpandedRowEmpleados(expandedRowEmpleados === id ? null : id)
    fetchEmpleadosById(user, id)
    setIdEmpresa(id)
  }

  const handleModalEmpresa = () => {
    setModalEmpresa(true)
  }

  // EDITAR EMPRESA
  const handleModalEditEmpresa = (id) => {
    const obj = empresas.find((e) => e.id_empresa === id)
    setObjEmpresa(JSON.stringify(obj))
    setIdEmpresa(id)
    setModalEmpresa(true)
  }

  const empleadosRef = useRef()

  return (
    <>
      <listaEmpresasContext.Provider value={{ user, idConsultora, idEmpresa, setIdEmpresa, objEmpresa, setObjEmpresa }}>
        <ModalEmpresa show={modalEmpresa} onHide={()=>setModalEmpresa(false)} />
        {loadingEmpresas ? (
          <div className='loading__ListaEmpresas my-3 d-flex flex-column align-items-center justify-content-center'>
            <Oval
              visible={true}
              height="40"
              width="40"
              color="#0d6efd"
              ariaLabel="oval-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
            <p className='fw-medium m-0 p-0'>Loading...</p>
          </div>
        ) : (
          <>
            {errorEmpresa ? (
              <div className='error__ListaEmpresas my-3 p-3 d-flex flex-column align-items-center justify-content-center rounded-3'>
                <h3 className='text-danger fw-semibold mb-2'>Oops!</h3>
                <p className='m-0 p-0'>{errorEmpresa}</p>
              </div>
            ) : (
              <>
                {empresas.length === 0 ? (
                  <div className='container__empresas--empty rounded-3 py-4 d-flex flex-column align-items-center justify-content-center'>
                    <h3 className='text-blue-500'>No tienes empresas aún.</h3>
                    <button onClick={handleModalEmpresa} className='btn btn-sm btn-outline-primary rounded-pill px-3 fw-medium'>+ Agregar empresa</button>
                  </div>
                ) : (
                  <div className='container__empresas'>
                    <div className='d-flex flex-row align-items-center mb-3'>
                      <h4 className='text-blue-500 m-0 pe-3'>Empresas</h4>
                      <button onClick={handleModalEmpresa} className='btn btn-sm btn-outline-primary rounded-pill px-3 fw-medium'>+ Agregar empresa</button>
                    </div>
                    <div className='table__customE'>
                      <div className='table__customE__header'>
                          <div className='table__customE__cell cellE__dropdown'></div>
                          <div className='table__customE__cell cellE__buttons fw-bold text-blue-500'></div>
                          <div className='table__customE__cell cellE__id fw-bold text-center text-blue-500'>#</div>
                          <div className='table__customE__cell cellE__name fw-bold text-blue-500'>Nombre</div>
                          <div className='table__customE__cell cellE__detalle fw-bold text-blue-500'>Detalle</div>
                          <div className='table__customE__cell cellE__space'></div>
                      </div>
                      <div className='table__customE__body'>
                        {empresas.map((e, i) => {
                          return <React.Fragment key={i}>
                            <div className='d-flex flex-row'>
                              <div className='table__customE__row bggray100'>
                                <div className='table__customE__cell cellE__dropdown'>
                                  <button className='btn__ico btn p-0' onClick={()=>handleEmpleadosById(e.id_empresa)}>
                                    {expandedRowEmpleados === e.id_empresa ? <i className="bi bi-chevron-up"></i> : <i className="bi bi-chevron-down"></i>}
                                  </button>
                                </div>
                                <div className='table__customE__cell cellE__buttons'>
                                  <button onClick={()=>handleModalEditEmpresa(e.id_empresa)} className='btn__ico--g btn border-0 p-0 btn__edit--icon'><i className="bi bi-pencil"></i></button>
                                </div>
                                <div className='table__customE__cell cellE__id text-center'>{e.id_empresa}</div>
                                <div className='table__customE__cell cellE__name'>{e.nombre}</div>
                                <div className='table__customE__cell cellE__detalle'>
                                  {e.banco === 1 && "Banco"}
                                  {e.banco === 0 && "No Banco"}
                                </div>
                                <div className='table__customE__cell cellE__space'></div>
                              </div>
                            </div>
                            <CSSTransition
                              in={expandedRowEmpleados === e.id_empresa}
                              timeout={100}
                              classNames="details"
                              unmountOnExit
                              nodeRef={empleadosRef}
                            >
                              <div ref={empleadosRef} className='container__AreaEmpleados d-flex flex-row'>
                                <div className='icon__listaFin d-none d-md-flex justify-content-end'>
                                  <img src={IcoList} alt=''/>
                                </div>
                                <div className='areaEmpleados'>
                                  <div className='container__listas rounded-3'>
                                    <ListaAreas />
                                    <ListaEmpleados />
                                  </div>
                                </div>
                              </div>
                            </CSSTransition>
                          </React.Fragment>
                        })}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </listaEmpresasContext.Provider>
    </>
  )
}

export default ListaEmpresas